import { ValueOf } from "src/types.d"

export const CreateOrEditOrganizationScreens = Object.freeze({
  SelectCategory: "SelectCategory",
  SelectSubCategory: "SelectSubCategory",
  CreateOrEditOrganization: "CreateOrEditOrganization",
} as const)

export type CreateOrEditOrganizationScreens = ValueOf<typeof CreateOrEditOrganizationScreens>
